export enum CONNECTIONS_PAYOUT_TYPE {
  ADJUSTMENT = 'ADJUSTMENT',
  BONUS = 'BONUS',
  STANDARD = 'STANDARD'
};
